import React, { useState, useEffect, useContext, useMemo } from "react";
import {
  Invoice,
  Client,
  Book,
  ClientReferal,
  PaymentStatus,
  TaxService,
} from "../../images";
import { Labelbox, Table, Button } from "../../components";
import "./dashboard.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { dateTimeFormatter, NotificationContext } from "../../utils/common";
import {
  CLIENT_ACTION,
  MESSAGE_ACTION,
  INVOICE_ACTION,
  DOCUMENT_ACTION,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import Empty from "antd/es/empty";
// NEW imports for toolbar UI
import SearchIcon from "@material-ui/icons/Search";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import { IconButton, Popover, TablePagination } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { ReactComponent as Calendar } from "../../images/calendar.svg";
import "../../components/table/table.scss";

// Date pickers are now handled via project-standard Labelbox component

// import { getUserFiles, deleteFile } from "../../redux/action/documentAction";

import { getRolePath } from "../../utils/common";
import { navigateToClientDetails } from "../../utils/clientDetailsSession";
import RequestedFilesBlock from "../../components/requestedFilesBlock";
import DashboardLoginCard from "../../components/DashboardLoginCard";
import LeaveNotificationPopup from "./LeaveNotificationPopup";
import { useClientCategoryTab } from "../../hooks/useClientCategoryTab";
import { buildRequestedFileDocumentsNavState } from "../../utils/requestedFilesDisplay";
import {
  buildClientDashboardCardCounts,
  formatDashboardCardValue,
} from "../../utils/dashboardCardCounts";

const MESSAGE_PAGER_OPTIONS = [5, 15, 25];

const MessagePagerActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

  return (
    <div className="message-thread-pager-actions">
      <IconButton
        onClick={(event) => onChangePage(event, 0)}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={(event) => onChangePage(event, page - 1)}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={(event) => onChangePage(event, page + 1)}
        disabled={page >= lastPage}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={(event) => onChangePage(event, lastPage)}
        disabled={page >= lastPage}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};

const getClientCard = () => [
  // {
  //   name: "Services We Offer",
  //   Icon: TaxService,
  //   count: "0",
  //   className: "card-0",
  //   path: getRolePath("/service_offers"),
  // },
  {
    name: "Documents",
    Icon: Book,
    count: "0",
    path: getRolePath("/documents"),
    className: "card-0",
  },
  {
    name: "Invoice",
    countKey: "Invoices",
    Icon: Invoice,
    count: "0",
    path: getRolePath("/payment"),
    className: "card-1",
  },
  {
    name: "Refer a friend",
    countKey: "Referrals",
    Icon: ClientReferal,
    count: "0",
    path: getRolePath("/referral"),
    className: "card-2",
  },
];

/** Admin, manager, and employee dashboard stat cards. */
const getStaffDashboardCards = () => [
  {
    name: "Clients",
    helperText: "Total clients",
    countKey: "Clients",
    Icon: Client,
    count: "0",
    path: getRolePath("/client"),
    className: "card-0",
  },
  {
    name: "Invoices",
    countKey: "Invoices",
    Icon: Invoice,
    count: "0",
    path: getRolePath("/invoice_contract"),
    className: "card-1",
    stateMode: "invoice",
  },
  // {
  //   name: "Payments",
  //   helperText: "Amount collected",
  //   countKey: "Payments",
  //   Icon: Payment,
  //   count: "0",
  //   format: "currency",
  //   className: "card-2",
  //   path: getRolePath("/invoice_contract"),
  //   stateMode: "invoice",
  // },
  {
    name: "Pending",
    helperText: "Amount pending",
    countKey: "Pending",
    Icon: PaymentStatus,
    count: "0",
    format: "currency",
    className: "card-3",
    path: getRolePath("/invoice_contract"),
    stateMode: "invoice",
  },
  {
    name: "Services",
    helperText: "Pending & completed services",
    countKey: "Services",
    Icon: TaxService,
    count: "0",
    className: "card-4",
    path: getRolePath("/pending_services"),
  },
];

const getAdminCard = () => getStaffDashboardCards();

const getManagerCard = () => getStaffDashboardCards();

const getEmployeeCard = () => getStaffDashboardCards();

// const clientHeader = [
//   { id: "1", label: "Client" },
//   { id: "2", label: "File" },
//   { id: "4", label: "File type" },
//   { id: "5", label: "File size" },
//   { id: "3", label: "Uploaded Date & Time" },
//   { id: "6", label: "Action" },
// ];

const activityHeader = [
  { id: "1", label: "S.No." },
  { id: "2", label: "Activity" },
  { id: "3", label: "Created At" },
];

const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  const parts = String(dateStr).split("-");
  if (parts.length !== 3) return new Date(dateStr);
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [leavePopupId, setLeavePopupId] = useState(null);
  const { notifications, notificationMeta } = useContext(NotificationContext);
  const activityTotalCount =
    notificationMeta?.total != null ? notificationMeta.total : notifications.length;
  const [q, setQ] = useState("");
  const [from, setFrom] = useState(null); // Date | null
  const [to, setTo] = useState(null); // Date | null

  // Calendar popover anchor
  const [calAnchor, setCalAnchor] = useState(null);
  const openCalendar = (e) => setCalAnchor(e.currentTarget);
  const closeCalendar = () => setCalAnchor(null);

  const [servicesCounts, setServicesCounts] = useState({ pending: 0, completed: 0 });

  // const { userFiles } = useSelector((state) => state.document);

  const navigate = useNavigate();
  const USER_ID = localStorage.getItem("user_id");
  const USER_TYPE = localStorage.getItem("user_role");
  const { categoryTab, hasBusinessAccess } = useClientCategoryTab();
  const firstName = localStorage.getItem("first_name") || "";
  const lastName = localStorage.getItem("last_name") || "";
  const fullName = `${firstName} ${lastName}`.trim() || "User";
  const card =
    USER_TYPE === "client"
      ? getClientCard()
      : USER_TYPE === "admin"
        ? getAdminCard()
        : USER_TYPE === "manager"
          ? getManagerCard()
          : getEmployeeCard();
  //console.log("the user role is ===>",USER_TYPE)
  // const card = USER_TYPE === "client" ? ClientCard : USER_TYPE === "admin" ?  AdminCard : USER_TYPE === "manager" ?  ManagerCard : EmployeeCard ;
  const { dashboardCardDetails } = useSelector((state) => state.client);
  const { allInvoices = [] } = useSelector((state) => state.invoice || {});
  const { allClientDocuments = [] } = useSelector(
    (state) => state.document || {},
  );
  const { unreadSummary } = useSelector((state) => state.message || {});
  const [messagePage, setMessagePage] = useState(0);
  const [messageRowsPerPage, setMessageRowsPerPage] = useState(5);

  const messageThreads = unreadSummary?.threads || [];
  const pagedMessageThreads = messageThreads.slice(
    messagePage * messageRowsPerPage,
    messagePage * messageRowsPerPage + messageRowsPerPage,
  );

  useEffect(() => {
    const lastPage = Math.max(
      0,
      Math.ceil(messageThreads.length / messageRowsPerPage) - 1,
    );
    if (messagePage > lastPage) setMessagePage(lastPage);
  }, [messageThreads.length, messagePage, messageRowsPerPage]);

  useEffect(() => {
    const payload =
      USER_TYPE === "client" && USER_ID
        ? { user_id: USER_ID, category: categoryTab }
        : USER_ID
          ? { user_id: USER_ID }
          : {};
    dispatch(CLIENT_ACTION.getDashboardCardDetails(payload));
  }, [dispatch, USER_TYPE, USER_ID, categoryTab]);

  useEffect(() => {
    if (USER_TYPE !== "client" || !USER_ID) return;
    dispatch(
      INVOICE_ACTION.getAllInvoices({
        billed_to: USER_ID,
        category: categoryTab,
      }),
    );
    dispatch(
      DOCUMENT_ACTION.getAllClientDocuments({
        user_id: USER_ID,
        document_category: categoryTab,
      }),
    );
  }, [dispatch, USER_TYPE, USER_ID, categoryTab]);

  useEffect(() => {
    dispatch(MESSAGE_ACTION.getUnreadMessageSummary());
  }, [dispatch]);

  useEffect(() => {
    const leaveId = location.state?.leave_id;
    if (!location.state?.openLeavePopup || !leaveId) return;
    setLeavePopupId(String(leaveId));
    navigate(location.pathname, { replace: true, state: null });
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    if (USER_TYPE === "client") return undefined;
    let cancelled = false;
    (async () => {
      try {
        const counts = await CLIENT_ACTION.getDashboardServicesCounts();
        if (!cancelled) setServicesCounts(counts);
      } catch (e) {
        if (!cancelled) setServicesCounts({ pending: 0, completed: 0 });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [USER_TYPE]);

  const displayCardDetails = useMemo(() => {
    if (USER_TYPE !== "client") {
      const base =
        dashboardCardDetails &&
        typeof dashboardCardDetails === "object" &&
        !Array.isArray(dashboardCardDetails)
          ? dashboardCardDetails
          : {};
      return {
        ...base,
        Services: base.Services ?? servicesCounts,
      };
    }
    return buildClientDashboardCardCounts({
      apiDetails: dashboardCardDetails,
      category: categoryTab,
      invoices: allInvoices,
      documents: allClientDocuments,
    });
  }, [
    USER_TYPE,
    dashboardCardDetails,
    categoryTab,
    allInvoices,
    allClientDocuments,
    servicesCounts,
  ]);

  // const onItemAction = async (type, actionData, index) => {
  //   // for delete the row
  //   const userData = userFiles[index];
  //   try {
  //     const response = await deleteFile({
  //       client_document_id: userData.client_document_id,
  //       folder_name: userData.folder_name,
  //       file_name: userData.document_name,
  //     });
  //     dispatch(getUserFiles(userFilePayload));
  //     if (response.status === 200 && response.data.status === 1) {
  //       Toaster.success("Document deleted successfully");
  //     } else {
  //       Toaster.error("Error occurred while deleting the document");
  //     }
  //   } catch (error) {
  //     Toaster.error("Error occurred while deleting the document");
  //   }
  // };

  const notificationData = useMemo(() => {
    return (
      notifications.map(({ message, createdAt }, index) => {
        return {
          s_no: index + 1,
          message,
          createdAt: dateTimeFormatter(createdAt),
        };
      }) || []
    );
  }, [notifications]);

  const filteredActivityRows = useMemo(() => {
    let rows = [...notificationData];

    if (q.trim()) {
      const re = new RegExp(q.trim(), "i");
      rows = rows.filter((r) => re.test(`${r.message}`));
    }

    const fromDate = from ? new Date(from + "T00:00:00") : null;
    const toDate = to ? new Date(to + "T23:59:59") : null;

    if (fromDate) {
      rows = rows.filter((r) => new Date(r.createdAt) >= fromDate);
    }
    if (toDate) {
      rows = rows.filter((r) => new Date(r.createdAt) <= toDate);
    }

    return rows;
  }, [notificationData, q, from, to]);

  return (
    <div className="dashboard-wrapper">
      {leavePopupId ? (
        <LeaveNotificationPopup
          leaveId={leavePopupId}
          onClose={() => setLeavePopupId(null)}
        />
      ) : null}
      {/* <h1 className="dashboard-greeting">Hi {fullName}!</h1> */}
      {/* ===== Stat cards + Login timer (staff) ===== */}
      <div className="dashboard-card-grid">
        {card.map((data) => {
          const countKey = data.countKey || data.name;
          const rawCount = displayCardDetails?.[countKey] ?? data.count ?? 0;
          const count = formatDashboardCardValue(rawCount, data.format);
          const onClickCard = () => {
            if (data.path) {
              const isInvoiceContractList =
                data.stateMode &&
                typeof data.path === "string" &&
                data.path.includes("/invoice_contract");
              let navigateState =
                data.stateMode &&
                (isInvoiceContractList
                  ? { mode: data.stateMode, listOnly: true }
                  : { mode: data.stateMode });
              if (navigateState && isInvoiceContractList) {
                if (data.name === "Payments") {
                  navigateState.filterStatus = "Paid";
                } else if (data.name === "Pending") {
                  navigateState.filterStatus = "Pending";
                }
              }
              navigate(data.path, { state: navigateState });
            }
          };

          return (
            <button
              key={data.name}
              type="button"
              className={`stat-card ${data.cursor ? "cursor" : ""}`}
              onClick={onClickCard}
              disabled={!data.path}
              aria-label={data.name}
            >
              <div className="stat-head">
                <span className="stat-icon">
                  <img src={data.Icon} alt="" />
                </span>
                <div className="stat-title-group">
                  <span className="stat-label">{data.name}</span>
                  {data.helperText ? (
                    <span className="stat-helper">{data.helperText}</span>
                  ) : null}
                </div>
              </div>
              {data.countKey === "Services" && typeof rawCount === "object" && rawCount !== null ? (
                <div className="stat-count stat-count--services">
                  <span className="stat-count-pill stat-count-pill--ongoing">
                    <span className="stat-count-num">{rawCount.pending}</span>
                    <span className="stat-count-label">Ongoing</span>
                  </span>
                  <span className="stat-count-divider">/</span>
                  <span className="stat-count-pill stat-count-pill--closed">
                    <span className="stat-count-num">{rawCount.completed}</span>
                    <span className="stat-count-label">Closed</span>
                  </span>
                </div>
              ) : (
                <div
                  className={`stat-count${
                    data.format === "currency" ? " stat-count--currency" : ""
                  }`}
                >
                  {count}
                </div>
              )}
            </button>
          );
        })}
        {USER_TYPE !== "client" ? <DashboardLoginCard /> : null}
      </div>

      {USER_TYPE === "client" && USER_ID ? (
        <div className="panel dashboard-requested-files-panel">
          <button
            type="button"
            className="dashboard-requested-files-heading"
            onClick={() =>
              navigate(getRolePath("/documents"), {
                state: {
                  documentsTab: "requested",
                  documentCategory: categoryTab,
                },
              })
            }
          >
            <h3 className="panel-title">Requested files</h3>
            <span className="dashboard-requested-files-heading-hint">
              Open in Documents
            </span>
          </button>
          <div className="dashboard-requested-files-body">
            <RequestedFilesBlock
              clientId={USER_ID}
              layoutMode="tableOnly"
              requestedFileCategory={categoryTab}
              showBusinessNameColumn={hasBusinessAccess}
              onRowClick={(row) =>
                navigate(getRolePath("/documents"), {
                  state: buildRequestedFileDocumentsNavState(row, categoryTab),
                })
              }
            />
          </div>
        </div>
      ) : null}

      {USER_TYPE !== "client" && (
        <div className="panel panel--messages">
          <div className="panel-heading">
            <h3 className="panel-title">Messages</h3>
          </div>

          {messageThreads.length ? (
            <>
              <div className="message-thread-list">
                {pagedMessageThreads.map((t) => (
                  <button
                    key={t?.client_id}
                    type="button"
                    className="message-thread-item"
                    onClick={() =>
                      navigateToClientDetails(navigate, t.client_id, {
                        state: { tab: "messages" },
                      })
                    }
                  >
                    <div className="message-thread-left">
                      <div className="message-thread-title">
                        {t?.client_name || "Client"}
                      </div>
                      <div className="message-thread-preview">
                        {t?.last_message || ""}
                      </div>
                    </div>
                    <div className="message-thread-right">
                      {t?.last_at ? (
                        <div className="message-thread-time">
                          {dateTimeFormatter(t.last_at)}
                        </div>
                      ) : null}
                      {Number(t?.unread_count || 0) > 0 ? (
                        <div className="message-unread-badge">
                          {Number(t.unread_count)}
                        </div>
                      ) : null}
                    </div>
                  </button>
                ))}
              </div>
              {messageThreads.length > 5 ? (
                <TablePagination
                  classes={{
                    root: "db-pager-root message-thread-pager",
                    toolbar: "db-pager-toolbar",
                    caption: "db-pager-caption",
                    actions: "db-pager-actions",
                    selectRoot: "db-pager-selectRoot",
                  }}
                  rowsPerPageOptions={MESSAGE_PAGER_OPTIONS}
                  component="div"
                  count={messageThreads.length}
                  rowsPerPage={messageRowsPerPage}
                  page={messagePage}
                  onChangePage={(_event, nextPage) => setMessagePage(nextPage)}
                  onChangeRowsPerPage={(event) => {
                    setMessageRowsPerPage(parseInt(event.target.value, 10));
                    setMessagePage(0);
                  }}
                  ActionsComponent={MessagePagerActions}
                />
              ) : null}
            </>
          ) : (
            <div style={{ padding: 16 }}>
              <Empty description="No unread messages" />
            </div>
          )}
        </div>
      )}

      {/* ===== Recent Activity panel ===== */}
      <div className="panel">
        <div className="panel-heading">
          <h3 className="panel-title">Recent Activity</h3>

          <div className="panel-tools">
            {/* Search like the image (rounded, leading icon) */}
            <div className="dash-search">
              <SearchIcon className="dash-search-icon" />
              <input
                type="text"
                placeholder="Search Client"
                aria-label="Search Client"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>

            {/* Calendar icon opens a date-range popover */}
            <IconButton
              // className="dash-icon-btn"
              onClick={openCalendar}
              aria-label="Open date filter"
            >
              <Calendar width={24} height={24} />
            </IconButton>

            {/* Filter icon (visual only like screenshot; keep for future) */}
            {/* <IconButton className="dash-icon-btn" aria-label="Filter">
        <FilterListOutlinedIcon />
      </IconButton> */}
          </div>
        </div>

        <Popover
          open={Boolean(calAnchor)}
          anchorEl={calAnchor}
          onClose={closeCalendar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{ className: "date-popover-paper" }}
        >
          <div className="date-popover">
            <div className="date-row">
              <Labelbox
                type="datepicker"
                labelname="From"
                value={from}
                changeData={(date) => setFrom(date)}
              />
              <Labelbox
                type="datepicker"
                labelname="To"
                value={to}
                changeData={(date) => setTo(date)}
              />
            </div>
            <div className="date-actions">
              <Button
                text="Clear"
                variant="outline"
                handleClick={() => {
                  setFrom("");
                  setTo("");
                }}
              />
              <Button text="Apply" handleClick={closeCalendar} />
            </div>
          </div>
        </Popover>

        {/* Pass a scoped class so ONLY this table gets the dashboard look */}
        <div className="dashboard-table-only">
          {" "}
          <Table
            title=""
            header={activityHeader}
            className={`dashboard-table`} // 👈 add this
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
            data={(() => {
              // Build filtered rows like the screenshot (frontend only)
              const base = notificationData;
              const regex = q.trim() ? new RegExp(q.trim(), "i") : null;

              const fromStart = from ? parseLocalDate(from) : null;
              if (fromStart) fromStart.setHours(0, 0, 0, 0);

              const toEnd = to ? parseLocalDate(to) : null;
              if (toEnd) toEnd.setHours(23, 59, 59, 999);

              return base.filter((r) => {
                // text filter
                const matchText = regex ? regex.test(`${r.message}`) : true;
                if (!matchText) return false;

                // date filter - parse display back (dateTimeFormatter output is usable by Date)
                const d = new Date(r.createdAt);
                if (fromStart && d < fromStart) return false;
                if (toEnd && d > toEnd) return false;
                return true;
              });
            })()}
            totalCount={activityTotalCount}
            aligncss="dashboard-table"
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
